(() => {

  const openRecipePrintView = (root, title) => {
    if (!root) { window.print(); return; }
    const popup = window.open('', '_blank');
    if (!popup) { window.print(); return; }
    const styles = Array.from(document.querySelectorAll('link[rel="stylesheet"]'))
      .map(link => `<link rel="stylesheet" href="${link.href}">`).join('');
    const inlineStyles = Array.from(document.querySelectorAll('style'))
      .map(style => `<style>${style.textContent || ''}</style>`).join('');
    const clone = root.cloneNode(true);
    clone.querySelectorAll('button, [data-kitchen-add], [data-kitchen-add-selection], .lello-recipe__commerce, .lello-kitchen-op__commerce, .lello-kitchen-op__utility').forEach(el => el.remove());
    clone.querySelectorAll('[hidden]').forEach(el => el.remove());
    popup.document.open();
    popup.document.write(`<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><title>${title || 'Lello Kitchen Recipe'}</title>${styles}${inlineStyles}<style>html,body{background:#fff!important}body{margin:0!important}.shopify-section-group-header-group,.shopify-section-group-footer-group,header,footer,.lello-ask-button{display:none!important}@page{margin:14mm}button{display:none!important}</style></head><body>${clone.outerHTML}</body></html>`);
    popup.document.close();
    const trigger = () => { try { popup.focus(); popup.print(); } catch (e) { window.print(); } };
    if (popup.document.readyState === 'complete') setTimeout(trigger, 350);
    else popup.addEventListener('load', () => setTimeout(trigger, 350), { once:true });
  };

  const root = document.querySelector('[data-lello-kitchen-op]');
  const recipeCountLabel = document.querySelector('[data-kitchen-recipe-count]');
  if (recipeCountLabel && Array.isArray(window.LELLO_KITCHEN_RECIPES)) {
    recipeCountLabel.textContent = `FIRST EDITION · ${window.LELLO_KITCHEN_RECIPES.length} RECIPES`;
  }
  if (!root) return;

  const journalView = document.querySelector('[data-lello-journal-view]');
  const journalShells = Array.from(document.querySelectorAll('.section-lello-journal-front-page, .section-house-note-01, [data-lello-journal-view]'));
  const indexView = root.querySelector('[data-kitchen-op-index]');
  const detailView = root.querySelector('[data-kitchen-op-detail]');
  const grid = root.querySelector('[data-kitchen-op-grid]');
  const recipeSource = root.querySelector('[data-kitchen-op-recipes]');
  const originalTitle = document.title;
  const managedMetaSelectors = [
    'meta[name="description"]',
    'meta[property="og:title"]',
    'meta[property="og:description"]',
    'meta[property="og:image"]',
    'meta[name="twitter:title"]',
    'meta[name="twitter:description"]',
    'meta[name="twitter:image"]'
  ];
  const originalMeta = new Map(managedMetaSelectors.map((selector) => {
    const element = document.querySelector(selector);
    return [selector, element ? element.getAttribute('content') : null];
  }));

  function setMetaContent(selector, value) {
    if (!value) return;
    let element = document.querySelector(selector);
    if (!element) {
      element = document.createElement('meta');
      if (selector.includes('property=')) element.setAttribute('property', selector.match(/property="([^"]+)"/)[1]);
      else element.setAttribute('name', selector.match(/name="([^"]+)"/)[1]);
      document.head.appendChild(element);
    }
    element.setAttribute('content', value);
    element.dataset.lelloKitchenManaged = 'true';
  }

  function applyRecipeMeta(recipe) {
    const title = recipe.seoTitle || `${recipe.title} | The Lello Kitchen`;
    const description = recipe.metaDescription || recipe.excerpt || '';
    document.title = title;
    setMetaContent('meta[name="description"]', description);
    setMetaContent('meta[property="og:title"]', title);
    setMetaContent('meta[property="og:description"]', description);
    setMetaContent('meta[name="twitter:title"]', title);
    setMetaContent('meta[name="twitter:description"]', description);
    if (recipe.image) {
      setMetaContent('meta[property="og:image"]', recipe.image);
      setMetaContent('meta[name="twitter:image"]', recipe.image);
    }
  }

  function restoreOriginalMeta() {
    managedMetaSelectors.forEach((selector) => {
      const element = document.querySelector(selector);
      const original = originalMeta.get(selector);
      if (original == null) {
        if (element && element.dataset.lelloKitchenManaged === 'true') element.remove();
      } else if (element) {
        element.setAttribute('content', original);
        delete element.dataset.lelloKitchenManaged;
      }
    });
  }

  let recipes = Array.isArray(window.LELLO_KITCHEN_RECIPES) ? window.LELLO_KITCHEN_RECIPES : [];
  if (!recipes.length) {
    try { recipes = JSON.parse(recipeSource ? recipeSource.textContent : '[]'); } catch (_) { recipes = []; }
  }
  const metaRecipeSource = root.querySelector('[data-kitchen-meta-recipes]');
  try {
    const adminRecipes = JSON.parse(metaRecipeSource ? metaRecipeSource.textContent : '[]');
    if (Array.isArray(adminRecipes) && adminRecipes.length) {
      const byId = new Map(recipes.map((recipe) => [recipe.id, recipe]));
      adminRecipes.forEach((entry) => { const recipe = entry.recipe ? {...entry.recipe, publishedAt: entry.publishedAt || entry.recipe.publishedAt} : entry; if (recipe && recipe.id) byId.set(recipe.id, recipe); });
      recipes = Array.from(byId.values());
    }
  } catch (_) {}
  const imageOverrides = window.LELLO_KITCHEN_IMAGE_OVERRIDES || {};
  recipes = recipes.map((recipe) => ({...recipe, image: imageOverrides[recipe.id] || (recipe.image && !String(recipe.image).includes('{{') ? recipe.image : '')}));

  recipes.sort((a, b) => (Date.parse(b.publishedAt) || 0) - (Date.parse(a.publishedAt) || 0));
  if (recipeCountLabel) recipeCountLabel.textContent = `THE COLLECTION · ${recipes.length} RECIPES`;

  const products = {};
  root.querySelectorAll('[data-kitchen-op-product]').forEach((el) => {
    products[el.dataset.handle] = {
      handle: el.dataset.handle,
      title: el.dataset.title || '',
      url: el.dataset.url || '#',
      price: el.dataset.priceLabel || '',
      variantId: Number(el.dataset.variant || 0),
      available: el.dataset.available === 'true',
      image: el.dataset.image || ''
    };
  });

  const escapeHTML = (value) => String(value == null ? '' : value).replace(/[&<>"']/g, (char) => ({
    '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'
  }[char]));

  const commonFractions = [
    [0.125,'⅛'],[0.25,'¼'],[1/3,'⅓'],[0.375,'⅜'],[0.5,'½'],[0.625,'⅝'],[2/3,'⅔'],[0.75,'¾'],[0.875,'⅞']
  ];

  function formatNumber(value, unit) {
    if (!Number.isFinite(value)) return '';
    const metricWhole = ['g','mL'].includes(unit);
    if (metricWhole && Math.abs(value) >= 8) return String(Math.round(value));
    if (unit === 'L') return (Math.round(value * 100) / 100).toString();
    const rounded = Math.round(value);
    if (Math.abs(value - rounded) < 0.02) return String(rounded);
    const whole = Math.floor(value + 1e-8);
    const frac = value - whole;
    for (const [v, symbol] of commonFractions) {
      if (Math.abs(frac - v) < 0.035) return whole ? `${whole} ${symbol}` : symbol;
    }
    const hundred = Math.round(value * 100) / 100;
    return String(hundred);
  }

  function ingredientList(items, factor) {
    return `<ul class="lello-kitchen-op__ingredients">${
      (items || []).map((item) => {
        const scale = item.scale === false ? 1 : factor;
        const q = item.q == null ? '' : formatNumber(Number(item.q) * scale, item.u || '');
        return `<li><span class="lello-kitchen-op__ingredient-qty">${escapeHTML(q)}${item.u ? ` <em>${escapeHTML(item.u)}</em>` : ''}</span><span>${escapeHTML(item.i)}</span></li>`;
      }).join('')
    }</ul>`;
  }

  function list(items, ordered = false) {
    const tag = ordered ? 'ol' : 'ul';
    return `<${tag} class="lello-kitchen-op__text-list">${(items || []).map((item) => `<li>${escapeHTML(item)}</li>`).join('')}</${tag}>`;
  }

  function primaryProduct(recipe) { return products[recipe.primaryProduct] || null; }

  function recipeUrl(recipe) {
    if (recipe && recipe.hashOnly) return `/pages/lello-kitchen#lello-kitchen/${encodeURIComponent(recipe.id)}`;
    return `/pages/recipe-${encodeURIComponent(recipe.id)}`;
  }

  function cardHTML(recipe, index) {
    const p = primaryProduct(recipe);
    const recipeImage = recipe.image || (p && p.image ? p.image : '');
    const image = recipeImage ? `<img src="${escapeHTML(recipeImage)}" alt="${escapeHTML(recipe.title)}" loading="${index === 0 ? 'eager' : 'lazy'}">` : `<div class="lello-kitchen-op__monogram">L</div>`;
    return `
      <article class="lello-kitchen-op-card${index === 0 ? ' lello-kitchen-op-card--featured' : ''}" data-kitchen-op-card data-tags="${escapeHTML((recipe.tags || []).join('|'))}">
        <a class="lello-kitchen-op-card__media" href="${recipeUrl(recipe)}" aria-label="Cook ${escapeHTML(recipe.title)}">${image}</a>
        <div class="lello-kitchen-op-card__body">
          <p class="lello-kitchen-op-card__eyebrow">${escapeHTML(recipe.eyebrow)}</p>
          <h2><a href="${recipeUrl(recipe)}">${escapeHTML(recipe.title)}</a></h2>
          <p>${escapeHTML(recipe.excerpt)}</p>
          <div class="lello-kitchen-op-card__meta"><span>${escapeHTML(recipe.prep)}</span><span>${escapeHTML(recipe.difficulty)}</span></div>
          <div class="lello-kitchen-op-card__actions">
            <a class="lello-kitchen-op-card__link" href="${recipeUrl(recipe)}">Cook this recipe</a>
            <button type="button" class="lello-kitchen-op-card__save" data-save-recipe="${escapeHTML(recipe.id)}" aria-label="Save ${escapeHTML(recipe.title)} to My Kitchen">♡ Save</button>
          </div>
        </div>
      </article>`;
  }

  function renderGrid() {
    if (!grid) return;
    grid.innerHTML = recipes.map(cardHTML).join('');
  }

  const fallbackProductImages = window.LELLO_KITCHEN_PRODUCT_FALLBACK_IMAGES || {};
  const productFallbacks = {
    'les-terres-blanches-smoked-fleur-de-sel-greece': {
      handle: 'les-terres-blanches-smoked-fleur-de-sel-greece',
      title: 'Les Terres Blanches Greek Smoked Fleur de Sel',
      url: '/products/les-terres-blanches-smoked-fleur-de-sel-greece',
      price: '', variantId: 0, available: true, image: fallbackProductImages['les-terres-blanches-smoked-fleur-de-sel-greece'] || ''
    },
    'clement-faugier-chestnut-paste-in-tube': {
      handle: 'clement-faugier-chestnut-paste-in-tube',
      title: 'Clément Faugier Chestnut Paste',
      url: '/products/clement-faugier-chestnut-paste-in-tube',
      price: '', variantId: 0, available: true, image: fallbackProductImages['clement-faugier-chestnut-paste-in-tube'] || ''
    },
    'sal-de-ibiza-fleur-de-sel-in-ceramic-jar': {
      handle: 'sal-de-ibiza-fleur-de-sel-in-ceramic-jar',
      title: 'Sal de Ibiza Fleur de Sel in Ceramic Jar',
      url: '/products/sal-de-ibiza-fleur-de-sel-in-ceramic-jar',
      price: '', variantId: 0, available: true, image: fallbackProductImages['sal-de-ibiza-fleur-de-sel-in-ceramic-jar'] || ''
    }
  };

  function productForHandle(handle) {
    if (products[handle]) return products[handle];
    if (productFallbacks[handle]) {
      products[handle] = {...productFallbacks[handle]};
      return products[handle];
    }
    const title = String(handle || '').split('-').filter(Boolean).map((part) => part.charAt(0).toUpperCase() + part.slice(1)).join(' ');
    products[handle] = { handle, title, url: `/products/${encodeURIComponent(handle)}`, price: '', variantId: 0, available: true, image: fallbackProductImages[handle] || '' };
    return products[handle];
  }

  const productFetchCache = new Map();

  function normalizeProductImage(src) {
    const value = String(src || '');
    return value.startsWith('//') ? `${window.location.protocol}${value}` : value;
  }

  function formatProductMoney(cents) {
    const amount = Number(cents || 0) / 100;
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ? window.Shopify.currency.active : 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(amount);
    } catch (_) {
      return `$${amount.toFixed(2)}`;
    }
  }

  async function hydrateProduct(product) {
    if (!product || product.variantId) return product;
    const handle = product.handle;
    if (!handle) return product;
    if (productFetchCache.has(handle)) return productFetchCache.get(handle);

    const request = (async () => {
      try {
        const response = await fetch(`${cartRoot()}products/${encodeURIComponent(handle)}.js`, {
          credentials: 'same-origin',
          headers: {'Accept':'application/json'}
        });
        if (!response.ok) return product;
        const data = await response.json();
        const variants = Array.isArray(data.variants) ? data.variants : [];
        const variant = variants.find((item) => item && item.available) || variants[0] || null;
        const image = normalizeProductImage(data.featured_image || (Array.isArray(data.images) ? data.images[0] : '') || product.image);
        Object.assign(product, {
          title: data.title || product.title,
          url: `${cartRoot()}products/${encodeURIComponent(data.handle || handle)}`,
          price: variant ? formatProductMoney(variant.price) : product.price,
          variantId: variant ? Number(variant.id || 0) : 0,
          available: variant ? Boolean(variant.available) : Boolean(data.available),
          image
        });
        products[handle] = product;
      } catch (_) {}
      return product;
    })();

    productFetchCache.set(handle, request);
    return request;
  }

  function productCard(product) {
    if (!product) return '';
    const image = product.image ? `<a href="${escapeHTML(product.url)}" class="lello-kitchen-op-product__image"><img src="${escapeHTML(product.image)}" alt="${escapeHTML(product.title)}" loading="lazy"></a>` : '';
    const actions = product.variantId
      ? `<a href="${escapeHTML(product.url)}">View product</a><button type="button" data-kitchen-add="${product.variantId}" ${!product.available ? 'disabled' : ''}>${product.available ? 'Add to cart' : 'Currently unavailable'}</button>`
      : `<a href="${escapeHTML(product.url)}">Shop product</a>`;
    return `<article class="lello-kitchen-op-product" data-kitchen-product-card="${escapeHTML(product.handle)}">
      ${image}
      <div>
        <p class="lello-kitchen-op-product__eyebrow">FROM THE LELLO EDIT</p>
        <h3><a href="${escapeHTML(product.url)}">${escapeHTML(product.title)}</a></h3>
        ${product.price ? `<p class="lello-kitchen-op-product__price">${escapeHTML(product.price)}</p>` : ''}
        <div class="lello-kitchen-op-product__actions">${actions}</div>
      </div>
    </article>`;
  }

  function panel(title, content, cls = '') {
    if (!content) return '';
    return `<section class="lello-kitchen-op__panel ${cls}"><h2>${escapeHTML(title)}</h2>${content}</section>`;
  }

  function renderDetail(recipe) {
    if (!recipe || !detailView) return;
    let factor = 1;
    let unit = 'us';
    const p = primaryProduct(recipe);
    const recipeImage = recipe.image || (p && p.image ? p.image : '');
    const image = recipeImage ? `<div class="lello-kitchen-op-recipe__image"><img src="${escapeHTML(recipeImage)}" alt="${escapeHTML(recipe.title)}"></div>` : '';
    const productList = (recipe.products || []).map((h) => productForHandle(h)).filter(Boolean);
    detailView.innerHTML = `
      <article class="lello-kitchen-op-recipe" data-kitchen-op-current>
        <header class="lello-kitchen-op-recipe__hero">
          <a class="lello-kitchen-op-recipe__back" href="#lello-kitchen">← All recipes</a>
          <p class="lello-kitchen-op__eyebrow">${escapeHTML(recipe.eyebrow)}</p>
          <h1>${escapeHTML(recipe.title)}</h1>
          <p>${escapeHTML(recipe.excerpt)}</p>
        </header>
        ${image}
        <div class="lello-kitchen-op-recipe__meta">
          <div><span>Prep</span><strong>${escapeHTML(recipe.prep)}</strong></div>
          <div><span>Cook</span><strong>${escapeHTML(recipe.cook)}</strong></div>
          <div><span>Yield</span><strong>${escapeHTML(recipe.yieldLabel)}</strong></div>
          <div><span>Difficulty</span><strong>${escapeHTML(recipe.difficulty)}</strong></div>
        </div>
        <div class="lello-kitchen-op-recipe__tools">
          <div>
            <span>Scale recipe</span>
            <button type="button" data-kitchen-factor="-0.5" aria-label="Decrease recipe scale">−</button>
            <strong data-kitchen-factor-value>1×</strong>
            <button type="button" data-kitchen-factor="0.5" aria-label="Increase recipe scale">+</button>
          </div>
          <div>
            <span>Measurements</span>
            <button type="button" class="is-active" data-kitchen-unit="us">US</button>
            <button type="button" data-kitchen-unit="metric">Metric</button>
          </div>
          <button type="button" data-save-recipe="${escapeHTML(recipe.id)}">♡ Save to My Kitchen</button>
          <button type="button" data-kitchen-share>Share recipe</button>
          <button type="button" data-kitchen-print>Print recipe</button>
        </div>
        <div class="lello-kitchen-op-recipe__layout">
          <aside>
            <section class="lello-kitchen-op__panel">
              <h2>Ingredients</h2>
              <div data-kitchen-ingredients></div>
            </section>
            ${panel('Mise en place', list(recipe.mise))}
          </aside>
          <div class="lello-kitchen-op-method">
            ${panel('Before you begin', `<p class="lello-kitchen-op__intro-copy">${escapeHTML(recipe.intro)}</p>`)}
            ${panel('Method', list(recipe.method, true), 'lello-kitchen-op__method')}
            ${panel('Chef’s notes', list(recipe.notes))}
            ${panel('Substitutions—with consequences', list(recipe.subs))}
            ${panel('To serve', `<p>${escapeHTML(recipe.serve)}</p>`)}
            ${panel('Storage & make-ahead', `<p>${escapeHTML(recipe.storage)}</p>`)}
          </div>
        </div>
        ${productList.length ? `<section class="lello-kitchen-op__commerce">
          <div class="container--page">
            <div class="lello-kitchen-op__commerce-head">
              <p class="lello-kitchen-op__eyebrow">THE LELLO PANTRY FOR THIS RECIPE</p>
              <h2>Shop this recipe.</h2>
              <p>The ingredients and objects from Lello that belong naturally with the preparation.</p>
            </div>
            <div class="lello-kitchen-op__products">${productList.map(productCard).join('')}</div>
            <div class="lello-kitchen-op__commerce-actions">
              ${productList.filter(x => x.available && x.variantId).length > 1 ? `<button class="lello-kitchen-op__selection-button" type="button" data-kitchen-add-selection>${escapeHTML(recipe.selectionLabel || 'Add the Lello selection to cart')}</button>` : ''}
              ${recipe.editUrl ? `<a class="lello-kitchen-op__edit-link" href="${escapeHTML(recipe.editUrl)}">${escapeHTML(recipe.editLabel || 'Explore the complete edit')}</a>` : ''}
            </div>
          </div>
        </section>` : ''}
        <aside class="lello-kitchen-op__utility">
          <div class="container--page">
            <p class="lello-kitchen-op__eyebrow">KEEP COOKING</p>
            <h2>Need to convert, scale or plan?</h2>
            <p>The Culinary Reference handles measurements and technical questions. The Lello Concierge can help build the rest of the table.</p>
            <div>
              <a href="/pages/culinary-reference">Open the Culinary Reference</a>
              <a href="/pages/concierge">Ask Lello</a>
              <a href="#lello-kitchen">All recipes</a>
            </div>
          </div>
        </aside>
      </article>`;

    const current = detailView.querySelector('[data-kitchen-op-current]');
    const ingredientTarget = current.querySelector('[data-kitchen-ingredients]');
    const factorValue = current.querySelector('[data-kitchen-factor-value]');

    const refreshIngredients = () => {
      ingredientTarget.innerHTML = ingredientList((recipe.ingredients && recipe.ingredients[unit]) || [], factor);
      factorValue.textContent = `${factor % 1 === 0 ? factor.toFixed(0) : factor.toFixed(1)}×`;
    };
    refreshIngredients();

    current.querySelectorAll('[data-kitchen-factor]').forEach((button) => button.addEventListener('click', () => {
      factor = Math.max(0.5, Math.min(4, factor + Number(button.dataset.kitchenFactor || 0)));
      refreshIngredients();
    }));

    current.querySelectorAll('[data-kitchen-unit]').forEach((button) => button.addEventListener('click', () => {
      unit = button.dataset.kitchenUnit || 'us';
      current.querySelectorAll('[data-kitchen-unit]').forEach((b) => b.classList.toggle('is-active', b === button));
      refreshIngredients();
    }));

    const share = current.querySelector('[data-kitchen-share]');
    if (share) share.addEventListener('click', async () => {
      const shareUrl = window.location.origin + recipeUrl(recipe);
      const shareTitle = recipe.title || 'Lello Kitchen Recipe';
      try {
        if (navigator.share) {
          await navigator.share({ title: shareTitle, text: recipe.excerpt || '', url: shareUrl });
        } else if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(shareUrl);
          const original = share.textContent;
          share.textContent = 'Link copied';
          setTimeout(() => { share.textContent = original; }, 1800);
        } else {
          window.prompt('Copy this recipe link:', shareUrl);
        }
      } catch (error) {
        if (error && error.name !== 'AbortError') window.prompt('Copy this recipe link:', shareUrl);
      }
    });

    const print = current.querySelector('[data-kitchen-print]');
    if (print) print.addEventListener('click', () => openRecipePrintView(current, recipe.title || 'Lello Kitchen Recipe'));

    const bindCommerceActions = () => {
      current.querySelectorAll('[data-kitchen-add]').forEach((button) => {
        if (button.dataset.kitchenBound === 'true') return;
        button.dataset.kitchenBound = 'true';
        button.addEventListener('click', () => addOne(button));
      });
      const selection = current.querySelector('[data-kitchen-add-selection]');
      if (selection && selection.dataset.kitchenBound !== 'true') {
        selection.dataset.kitchenBound = 'true';
        selection.addEventListener('click', () => addSelection(recipe, selection));
      }
    };
    const prepareSelection = async () => {
      const service = window.LelloPairings;
      if (!service) { document.addEventListener('lello:pairings-ready', prepareSelection, {once:true}); return; }
      const commerce = current.querySelector('.lello-kitchen-op__commerce');
      if (!commerce) return;
      let status = commerce.querySelector('[data-lp-status]');
      if (!status) { status = document.createElement('p'); status.dataset.lpStatus = ''; status.className = 'lp-status'; status.setAttribute('role', 'status'); commerce.querySelector('.lello-kitchen-op__commerce-actions').append(status); }
      const update = () => {
        const chosen = [...commerce.querySelectorAll('[data-kitchen-choice]:checked')];
        const button = commerce.querySelector('[data-kitchen-add-selection]');
        if (button) { button.disabled = !chosen.length; button.textContent = chosen.length ? service.copy('selected', {count: chosen.length, price: service.money(chosen.reduce((sum, input) => sum + Number(input.dataset.price), 0))}) : service.copy('choose'); }
      };
      await Promise.all([...commerce.querySelectorAll('[data-kitchen-product-card]')].map(async card => {
        if (card.querySelector('[data-kitchen-choice]')) return;
        try {
          const item = await service.product(card.dataset.kitchenProductCard);
          if (!item.available || item.excluded || !card.isConnected) return;
          const label = document.createElement('label'); label.className = 'lp-select';
          const input = document.createElement('input'); input.type = 'checkbox'; input.dataset.kitchenChoice = item.handle; input.dataset.price = item.price;
          const span = document.createElement('span'); span.textContent = service.copy('recipe_select'); label.append(input, span);
          card.querySelector('.lello-kitchen-op-product__actions').before(label); input.addEventListener('change', update);
        } catch (_) {}
      }));
      update();
    };
    bindCommerceActions();
    prepareSelection();

    const unresolvedProducts = productList.filter((product) => product && !product.variantId);
    if (unresolvedProducts.length) {
      Promise.all(unresolvedProducts.map((product) => hydrateProduct(product))).then(() => {
        if (!current.isConnected) return;
        const productGrid = current.querySelector('.lello-kitchen-op__products');
        if (!productGrid) return;
        productGrid.innerHTML = productList.map(productCard).join('');

        const commerceActions = current.querySelector('.lello-kitchen-op__commerce-actions');
        const purchasableCount = productList.filter((product) => product && product.available && product.variantId).length;
        let selection = current.querySelector('[data-kitchen-add-selection]');
        if (purchasableCount > 1 && !selection && commerceActions) {
          selection = document.createElement('button');
          selection.className = 'lello-kitchen-op__selection-button';
          selection.type = 'button';
          selection.dataset.kitchenAddSelection = '';
          selection.textContent = recipe.selectionLabel || 'Add the Lello selection to cart';
          commerceActions.prepend(selection);
        } else if (purchasableCount <= 1 && selection) {
          selection.remove();
        }
        bindCommerceActions();
        prepareSelection();
      });
    }

    injectRecipeSchema(recipe, p);
    syncSaveButtons();
  }

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  }

  async function addItems(items) {
    const response = await fetch(`${cartRoot()}cart/add.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items})
    });
    if (!response.ok) throw new Error('Unable to add to cart');

    const added = await response.json();
    const cart = await refreshCartCount();

    // Recipe additions bypass the theme's native product-form, so explicitly
    // refresh the drawer sections that would otherwise remain in their initial
    // server-rendered state (often "Your cart is empty").
    await refreshCartDrawerUI();

    // Keep the rest of the theme's cart-aware features in sync as well.
    document.dispatchEvent(new CustomEvent('lello:cart-changed'));
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lello-kitchen', cartData: cart || added });
    }

    return added;
  }

  async function refreshCartDrawerUI() {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    try {
      const url = new URL(window.location.href);
      url.searchParams.set('sections', 'cart-items,cart-footer,cart-drawer-icon-bubble,cart-icon-bubble,cart-live-region-text');
      const response = await fetch(url.toString(), {
        credentials: 'same-origin',
        headers: {'Accept':'application/json'}
      });
      if (!response.ok) return;

      const sections = await response.json();
      const parser = new DOMParser();

      const replaceFromSection = (sectionId, currentSelector, sourceSelector) => {
        const html = sections[sectionId];
        if (!html) return;
        const doc = parser.parseFromString(html, 'text/html');
        const source = doc.querySelector(sourceSelector);
        const current = document.querySelector(currentSelector);
        if (source && current) current.replaceWith(source);
      };

      replaceFromSection('cart-items', '#cart-drawer cart-items', 'cart-items');
      replaceFromSection('cart-footer', '#cart-drawer #cart-footer', '#cart-footer');

      const drawerBubbleHtml = sections['cart-drawer-icon-bubble'];
      if (drawerBubbleHtml) {
        const doc = parser.parseFromString(drawerBubbleHtml, 'text/html');
        const source = doc.querySelector('.site-header__cart-indicator');
        const current = document.querySelector('#cart-drawer-icon-bubble .site-header__cart-indicator');
        if (source && current) current.replaceWith(source);
      }

      const headerBubbleHtml = sections['cart-icon-bubble'];
      if (headerBubbleHtml) {
        const doc = parser.parseFromString(headerBubbleHtml, 'text/html');
        const source = doc.querySelector('.site-header__cart-indicator');
        const current = document.querySelector('#cart-drawer-opener .site-header__cart-indicator');
        if (source && current) current.replaceWith(source);
      }
    } catch (_) {
      // The count refresh below still provides a graceful fallback.
    }
  }

  async function refreshCartCount() {
    try {
      const response = await fetch(`${cartRoot()}cart.js`, {headers:{'Accept':'application/json'}});
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('.site-header__cart-indicator').forEach((indicator) => {
        let count = indicator.querySelector('.site-header__cart-count');
        if (cart.item_count > 0) {
          if (!count) {
            count = document.createElement('div');
            count.className = 'site-header__cart-count';
            indicator.appendChild(count);
          }
          count.innerHTML = `<span aria-hidden="true">${cart.item_count < 100 ? cart.item_count : ''}</span><span class="display--hidden">${cart.item_count} items</span>`;
        } else if (count) count.remove();
      });
      return cart;
    } catch (_) {
      return null;
    }
  }

  async function addOne(button) {
    const variantId = Number(button.dataset.kitchenAdd || 0);
    if (!variantId) return;
    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    try {
      await addItems([{id:variantId, quantity:1}]);
      button.textContent = 'Added ✓';
    } catch (_) {
      button.disabled = false;
      button.textContent = original;
    }
  }

  async function addSelection(recipe, button) {
    const service = window.LelloPairings;
    const commerce = button.closest('.lello-kitchen-op__commerce');
    if (!service || !commerce) return;
    const items = [...commerce.querySelectorAll('[data-kitchen-choice]:checked')].map(input => ({handle:input.dataset.kitchenChoice, price:Number(input.dataset.price)}));
    await service.addSelected(items, button, commerce.querySelector('[data-lp-status]'), 'kitchen-recipe');
  }

  function removeRecipeSchema() {
    const existing = document.getElementById('lello-kitchen-current-schema');
    if (existing) existing.remove();
  }

  function injectRecipeSchema(recipe, product) {
    removeRecipeSchema();
    const preferredSchemaUnit = recipe.schemaUnit && recipe.ingredients && recipe.ingredients[recipe.schemaUnit]
      ? recipe.schemaUnit
      : (recipe.ingredients && recipe.ingredients.metric ? 'metric' : 'us');
    const ingredients = ((recipe.ingredients && recipe.ingredients[preferredSchemaUnit]) || []).map((item) => {
      const q = item.q == null ? '' : `${formatNumber(Number(item.q), item.u || '')}${item.u ? ` ${item.u}` : ''}`;
      return `${q}${q ? ' ' : ''}${item.i}`.trim();
    });
    const schema = {
      '@context':'https://schema.org',
      '@type':'Recipe',
      name:recipe.title,
      description:recipe.excerpt,
      image:recipe.image ? [recipe.image] : (product && product.image ? [product.image] : undefined),
      author:{'@type':'Organization',name:'Lello Kitchen'},
      recipeYield:recipe.schemaYield || recipe.yieldLabel,
      recipeCategory:recipe.category,
      recipeCuisine:recipe.cuisine || undefined,
      prepTime:recipe.prepTimeISO || undefined,
      cookTime:recipe.cookTimeISO || undefined,
      totalTime:recipe.totalTimeISO || undefined,
      suitableForDiet:recipe.suitableForDiet || undefined,
      keywords:[...(recipe.tags || []), recipe.primarySearchPhrase || '', ...((recipe.secondarySearchPhrases || []))].filter(Boolean).join(', '),
      recipeIngredient:ingredients,
      recipeInstructions:(recipe.method || []).map((step) => ({'@type':'HowToStep',text:step})),
      url:`${location.origin}${location.pathname}${location.search}#lello-kitchen/${recipe.id}`
    };
    ['image','recipeCuisine','prepTime','cookTime','totalTime','suitableForDiet'].forEach((key) => { if (!schema[key]) delete schema[key]; });
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'lello-kitchen-current-schema';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
  }


  // --- My Kitchen: browser-persistent saved recipes, menus and shopping list ---
  const myKitchen = root.querySelector('[data-my-kitchen]');
  const myKitchenBody = root.querySelector('[data-my-kitchen-body]');
  const myKitchenCount = root.querySelectorAll('[data-my-kitchen-count]');
  const STORAGE_KEY = 'lello_my_kitchen_v1';
  let myState = {saved:[], menu:[], menuName:'My Menu'};
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    myState = {...myState, ...stored};
    if (!Array.isArray(myState.saved)) myState.saved = [];
    if (!Array.isArray(myState.menu)) myState.menu = [];
  } catch (_) {}

  const persistMyKitchen = () => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(myState)); } catch (_) {}
    updateMyKitchenCount();
    syncSaveButtons();
  };

  const updateMyKitchenCount = () => myKitchenCount.forEach((el) => { el.textContent = String(myState.saved.length); });
  const isSaved = (id) => myState.saved.includes(id);

  function syncSaveButtons() {
    root.querySelectorAll('[data-save-recipe]').forEach((button) => {
      const saved = isSaved(button.dataset.saveRecipe || '');
      button.classList.toggle('is-saved', saved);
      button.textContent = saved ? '♥ Saved' : (button.closest('.lello-kitchen-op-recipe__tools') ? '♡ Save to My Kitchen' : '♡ Save');
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    });
  }

  function toggleSaved(id) {
    if (!id) return;
    if (isSaved(id)) {
      myState.saved = myState.saved.filter((x) => x !== id);
      myState.menu = myState.menu.filter((x) => x !== id);
    } else {
      myState.saved.push(id);
    }
    persistMyKitchen();
    if (myKitchen && !myKitchen.hidden) renderMyKitchen();
  }

  function savedRecipes() { return myState.saved.map((id) => recipes.find((r) => r.id === id)).filter(Boolean); }
  function menuRecipes() { return myState.menu.map((id) => recipes.find((r) => r.id === id)).filter(Boolean); }

  function uniqueProductsFor(recipesList) {
    const handles = [];
    recipesList.forEach((r) => (r.products || []).forEach((h) => { if (!handles.includes(h)) handles.push(h); }));
    return handles.map((h) => productForHandle(h)).filter(Boolean);
  }

  const lelloIngredientTerms = [
    'lello dirty martini juice','dirty martini juice','rose petal confit','jasmine flower confit','jasmine confit',
    'heritage extra virgin olive oil','triana olivas mediterranean capers','mediterranean capers','sicilian lemon sea salt',
    'lavender honey','theta rare rose honey','rare rose honey','rose honey','lemon-infused extra virgin olive oil','truffle-infused extra virgin olive oil','fig jam',
    'mustard with lemon zest and thyme','périgord truffle mustard','perigord truffle mustard','wild strawberry jam','wild blueberry jam','apple, pear & walnut jam','apple, pear and walnut jam','violet flower confit','acacia honey','marie antoinette loose leaf tea','paris je t’aime loose-leaf tea','paris je taime loose leaf tea','dirty martini juice','blue cheese stuffed olives','basil infused extra virgin olive oil','lavender olive oil','le marké organic balsamic vinegar','le marke organic balsamic vinegar','the butcher salt','clément faugier chestnut paste','clement faugier chestnut paste','sal de ibiza fleur de sel','greek smoked fleur de sel','smoked fleur de sel'
  ];
  const isLelloIngredient = (name) => lelloIngredientTerms.some((term) => String(name || '').toLowerCase().includes(term));

  function consolidateMarketIngredients(list) {
    const map = new Map();
    list.forEach((recipe) => {
      const items = (recipe.ingredients && recipe.ingredients.us) || [];
      items.forEach((item) => {
        if (isLelloIngredient(item.i)) return;
        const key = `${String(item.i).toLowerCase()}|${item.u || ''}`;
        if (!map.has(key)) map.set(key, {q:0, numeric:true, u:item.u || '', i:item.i});
        const row = map.get(key);
        const n = Number(item.q);
        if (Number.isFinite(n) && item.scale !== false) row.q += n;
        else { row.numeric = false; row.q = item.q == null ? '' : item.q; }
      });
    });
    return Array.from(map.values()).map((row) => ({...row, label: row.numeric && Number.isFinite(row.q) ? `${formatNumber(row.q,row.u)}${row.u ? ` ${row.u}` : ''}` : (row.q ? String(row.q) : '')}));
  }

  function renderSavedTab() {
    const saved = savedRecipes();
    if (!saved.length) return `<div class="lello-my-kitchen__empty"><p class="lello-kitchen-op__eyebrow">YOUR RECIPE FOLIO</p><h3>Nothing saved yet.</h3><p>Use “Save to My Kitchen” on any recipe and it will appear here on this device.</p></div>`;
    return `<div class="lello-my-kitchen__saved-grid">${saved.map((r) => {
      const p = primaryProduct(r); const img = r.image || (p && p.image ? p.image : '');
      return `<article class="lello-my-kitchen__saved-card">${img ? `<a href="${recipeUrl(r)}" data-my-kitchen-navigate><img src="${escapeHTML(img)}" alt="${escapeHTML(r.title)}"></a>` : ''}<div><p>${escapeHTML(r.eyebrow)}</p><h3><a href="${recipeUrl(r)}" data-my-kitchen-navigate>${escapeHTML(r.title)}</a></h3><button type="button" data-remove-saved="${escapeHTML(r.id)}">Remove</button></div></article>`;
    }).join('')}</div>`;
  }

  function renderMenuTab() {
    const saved = savedRecipes();
    if (!saved.length) return `<div class="lello-my-kitchen__empty"><h3>Save a few recipes first.</h3><p>Your menu is built from recipes in your personal folio.</p></div>`;
    return `<div class="lello-my-kitchen__menu-builder"><label class="lello-my-kitchen__menu-name"><span>Menu name</span><input type="text" value="${escapeHTML(myState.menuName || 'My Menu')}" data-menu-name></label><p>Select the courses you want to cook together. Lello will consolidate the pantry and market list.</p><div class="lello-my-kitchen__menu-options">${saved.map((r) => `<label><input type="checkbox" value="${escapeHTML(r.id)}" data-menu-recipe ${myState.menu.includes(r.id) ? 'checked' : ''}><span><small>${escapeHTML(r.eyebrow)}</small><strong>${escapeHTML(r.title)}</strong></span></label>`).join('')}</div><button type="button" class="lello-my-kitchen__primary" data-save-menu>Save this menu</button></div>`;
  }

  function renderShoppingTab() {
    const selected = menuRecipes();
    const base = selected.length ? selected : savedRecipes();
    if (!base.length) return `<div class="lello-my-kitchen__empty"><h3>Your shopping list begins with a menu.</h3><p>Save recipes, build a menu, and Lello will separate pantry pieces from fresh-market ingredients.</p></div>`;
    const pantry = uniqueProductsFor(base);
    const market = consolidateMarketIngredients(base);
    return `<div class="lello-my-kitchen__shopping"><header><p class="lello-kitchen-op__eyebrow">${escapeHTML(myState.menuName || 'MY MENU')}</p><h3>${base.length} recipe${base.length === 1 ? '' : 's'}, one list.</h3></header><section><h4>From the Lello Pantry</h4><div class="lello-my-kitchen__pantry-list">${pantry.map((p) => `<div><a href="${escapeHTML(p.url)}">${escapeHTML(p.title)}</a><strong>${escapeHTML(p.price)}</strong></div>`).join('')}</div>${pantry.some((p) => p.available && p.variantId) ? '<button type="button" class="lello-my-kitchen__primary" data-add-menu-pantry>Add the Lello Pantry to cart</button>' : ''}</section><section><h4>From the market</h4><ul class="lello-my-kitchen__market-list">${market.map((i) => `<li><span>${escapeHTML(i.label)}</span><strong>${escapeHTML(i.i)}</strong></li>`).join('')}</ul><button type="button" data-print-shopping>Print shopping list</button></section></div>`;
  }

  let activeMyKitchenTab = 'saved';
  function renderMyKitchen() {
    if (!myKitchenBody) return;
    if (activeMyKitchenTab === 'menu') myKitchenBody.innerHTML = renderMenuTab();
    else if (activeMyKitchenTab === 'shopping') myKitchenBody.innerHTML = renderShoppingTab();
    else myKitchenBody.innerHTML = renderSavedTab();
    root.querySelectorAll('[data-my-kitchen-tab]').forEach((b) => b.classList.toggle('is-active', b.dataset.myKitchenTab === activeMyKitchenTab));
  }

  function openMyKitchen(tab = 'saved') {
    if (!myKitchen) return;
    activeMyKitchenTab = tab;
    renderMyKitchen();
    myKitchen.hidden = false;
    document.body.classList.add('lello-my-kitchen-open');
  }
  function closeMyKitchen() {
    if (!myKitchen) return;
    myKitchen.hidden = true;
    document.body.classList.remove('lello-my-kitchen-open');
  }

  root.addEventListener('click', async (event) => {
    const save = event.target.closest('[data-save-recipe]');
    if (save) { event.preventDefault(); toggleSaved(save.dataset.saveRecipe); return; }
    if (event.target.closest('[data-my-kitchen-open]')) { event.preventDefault(); openMyKitchen(); return; }
    if (event.target.closest('[data-my-kitchen-close]')) { event.preventDefault(); closeMyKitchen(); return; }
    const tab = event.target.closest('[data-my-kitchen-tab]');
    if (tab) { activeMyKitchenTab = tab.dataset.myKitchenTab || 'saved'; renderMyKitchen(); return; }
    const remove = event.target.closest('[data-remove-saved]');
    if (remove) { toggleSaved(remove.dataset.removeSaved); return; }
    if (event.target.closest('[data-my-kitchen-navigate]')) { closeMyKitchen(); return; }
    const saveMenu = event.target.closest('[data-save-menu]');
    if (saveMenu) {
      myState.menu = Array.from(root.querySelectorAll('[data-menu-recipe]:checked')).map((x) => x.value);
      const input = root.querySelector('[data-menu-name]'); if (input) myState.menuName = input.value.trim() || 'My Menu';
      persistMyKitchen(); activeMyKitchenTab = 'shopping'; renderMyKitchen(); return;
    }
    const addPantry = event.target.closest('[data-add-menu-pantry]');
    if (addPantry) {
      const base = menuRecipes().length ? menuRecipes() : savedRecipes();
      const items = uniqueProductsFor(base).filter((p) => p.available && p.variantId).map((p) => ({id:p.variantId,quantity:1}));
      if (!items.length) return;
      addPantry.disabled = true; const oldText = addPantry.textContent; addPantry.textContent = 'Adding…';
      try { await addItems(items); addPantry.textContent = 'Pantry added ✓'; } catch (_) { addPantry.disabled = false; addPantry.textContent = oldText; }
      return;
    }
    if (event.target.closest('[data-print-shopping]')) {
      const content = root.querySelector('.lello-my-kitchen__shopping');
      if (content) openRecipePrintView(content, `${myState.menuName || 'My Menu'} | Lello Kitchen`);
    }
  });

  updateMyKitchenCount();
  function showKitchen(recipeId) {
    root.hidden = false;
    journalShells.forEach((section) => { if (section && !section.contains(root)) section.hidden = true; });
    document.body.classList.add('lello-kitchen-op-open');

    if (recipeId) {
      const recipe = recipes.find((r) => r.id === recipeId);
      if (recipe) {
        indexView.hidden = true;
        detailView.hidden = false;
        renderDetail(recipe);
        applyRecipeMeta(recipe);
      } else {
        indexView.hidden = false;
        detailView.hidden = true;
        document.title = 'The Lello Kitchen | Lello.Store';
        restoreOriginalMeta();
        removeRecipeSchema();
      }
    } else {
      indexView.hidden = false;
      detailView.hidden = true;
      detailView.innerHTML = '';
      document.title = 'The Lello Kitchen | Lello.Store';
      restoreOriginalMeta();
      removeRecipeSchema();
    }
    requestAnimationFrame(() => {
      const top = Math.max(0, root.getBoundingClientRect().top + window.scrollY - 24);
      window.scrollTo({top, behavior:'auto'});
    });
  }

  function showJournal() {
    root.hidden = true;
    journalShells.forEach((section) => { if (section) section.hidden = false; });
    document.body.classList.remove('lello-kitchen-op-open');
    document.title = originalTitle;
    restoreOriginalMeta();
    removeRecipeSchema();
  }

  function route() {
    const hash = decodeURIComponent(location.hash || '');
    if (location.pathname.replace(/\/$/,'') === '/pages/lello-kitchen' && !hash.startsWith('#lello-kitchen')) { showKitchen(''); return; }
    if (!hash.startsWith('#lello-kitchen')) {
      showJournal();
      return;
    }
    const parts = hash.replace(/^#lello-kitchen\/?/, '').split('/').filter(Boolean);
    showKitchen(parts[0] || '');
  }

  renderGrid();
  syncSaveButtons();

  const filterButtons = root.querySelectorAll('[data-kitchen-op-filter]');
  filterButtons.forEach((button) => button.addEventListener('click', () => {
    const filter = button.dataset.kitchenOpFilter || 'all';
    filterButtons.forEach((b) => b.classList.toggle('is-active', b === button));
    root.querySelectorAll('[data-kitchen-op-card]').forEach((card) => {
      const tags = (card.dataset.tags || '').split('|');
      card.hidden = filter !== 'all' && !tags.includes(filter);
    });
  }));

  window.addEventListener('hashchange', route);
  route();
})();
